
import { AnyAction } from "redux"
import { NOTIFICATIONS_COUNT_DATA_FAIL, NOTIFICATIONS_COUNT_DATA_REQ, NOTIFICATIONS_COUNT_DATA_SUCC, NOTIFICATIONS_DATA_FAIL, NOTIFICATIONS_DATA_REQ, NOTIFICATIONS_DATA_SUCC } from "redux/actions/notifications/type"


interface State {
    loading?: boolean
    data?: any,
    error?: string,


}

const defaultState: State = {
    loading: false,
    data: [],


}


 

// export const NOTIFICATIONS_COUNT_DATA_FAIL="NOTIFICATIONS_COUNT_DATA_FAIL"
// export const NOTIFICATIONS_COUNT_DATA_REQ="NOTIFICATIONS_COUNT_DATA_REQ"
// export const NOTIFICATIONS_COUNT_DATA_SUCC="NOTIFICATIONS_COUNT_DATA_SUCC"

export const getNotificationsCountsReducer = (state: State = defaultState, action: AnyAction) => {
    switch (action.type) {
        case NOTIFICATIONS_COUNT_DATA_REQ:

            return {
                loading: true,
                data: state.data
            }
        case NOTIFICATIONS_COUNT_DATA_SUCC:

            return {
                loading: false,
                data: action.payload,

            }
        case NOTIFICATIONS_COUNT_DATA_FAIL:
            return {
                loading: false,
                error: action.payload
            }


        default:
            return state;
    }
}